/** `source` PostHog gets for an action started from the properties panel. */
export const TRACK_SOURCE_PANEL = "panel";
/** `source` PostHog gets for an action started from the element toolbar. */
export const TRACK_SOURCE_TOOLBAR = "toolbar";
